import {
  ADMIN_GET_USER_ORDERS_SUCCESS
} from './admin'

export const initialState = {
  list: [],
  pages: 0,
  last: false,
  currentPage: 0,
  loading: false
}

export const GET_ORDERS_REQUEST = 'GET_ORDERS_REQUEST'
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS'
export const GET_ORDERS_ERROR = 'GET_ORDERS_ERROR'

export const getOrders = ({ userId, page, size }) => (dispatch, getState, { httpRequest }) => {
  const currentUserId = getState().user.details.id

  dispatch({ type: GET_ORDERS_REQUEST })

  return httpRequest.get(`/orders/${userId}/${page}`, {
    params: {
      size
    }
  })
    .then(res => {
      if (currentUserId === userId) {
        dispatch({
          type: GET_ORDERS_SUCCESS,
          orders: res.data
        })
      } else {
        dispatch({
          type: ADMIN_GET_USER_ORDERS_SUCCESS,
          orders: res.data
        })
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      dispatch({
        type: GET_ORDERS_ERROR
      })
      console.error(err)
      return Promise.reject()
    })
}

const ACTION_HANDLERS = {
  [GET_ORDERS_REQUEST]: state => ({
    ...state,
    list: [],
    loading: true
  }),
  [GET_ORDERS_SUCCESS]: (state, { orders }) => ({
    ...state,
    list: orders.rows,
    count: orders.count,
    last: orders.last,
    pages: orders.pages,
    loading: false
  })
}

export default function ordersReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/orders.js